export default {
    API_URL: 'https://speakers.azurewebsites.net/api/v1/',
    TRAVEL_URL: 'https://speaker-hotels.azurewebsites.net/api/v1/',
    CURRENT_HOTEL: '2080294c-0d46-43d5-9210-2a8f30344878'
}